// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.investor-detail-page-container {
  width: 100%;
}
.investor-detail-page-container .content {
  animation: fadeIn 1s;
}
.investor-detail-page-container .content .hero-banner {
  width: 100%;
  max-height: 520px;
  object-fit: contain;
}
.investor-detail-page-container .content .about {
  display: flex;
  width: 100%;
  margin-top: 80px;
  font-family: "Proxima Nova", sans-serif;
  color: var(--secondary-color-1);
}
.investor-detail-page-container .content .about > div {
  width: 100%;
}
.investor-detail-page-container .content .about div:first-child {
  flex: 1 1;
}
.investor-detail-page-container .content .about div:first-child p {
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  margin: 0;
}
.investor-detail-page-container .content .about div:last-child {
  flex: 2 1;
}
.investor-detail-page-container .content .about div:last-child span {
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  text-align: justify;
}
.investor-detail-page-container .content .highlights {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.investor-detail-page-container .content .highlights .top-header {
  color: var(--primary-color-1);
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.investor-detail-page-container .content .highlights .header {
  font-size: 40px;
  color: var(--secondary-color-1);
  font-weight: 700;
  margin: 0;
}
.investor-detail-page-container .content .highlights .highlight {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 20px;
}
.investor-detail-page-container .content .highlights .highlight > div {
  max-width: 320px;
  background-color: #FFF8E2;
  border-radius: 40px;
  padding: 50px;
}
.investor-detail-page-container .content .highlights .highlight > div .number, .investor-detail-page-container .content .highlights .highlight > div .title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.investor-detail-page-container .content .highlights .highlight > div .number {
  color: var(--primary-color-1);
  margin-bottom: 16px;
}
.investor-detail-page-container .content .highlights .highlight > div .title {
  color: var(--secondary-color-1);
  margin-bottom: 18px;
}
.investor-detail-page-container .content .highlights .highlight > div .desc {
  color: var(--secondary-color-1);
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
}
.investor-detail-page-container .content .market {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  column-gap: 100px;
}
.investor-detail-page-container .content .market > div {
  flex: 1 1;
}
.investor-detail-page-container .content .market .image {
  border-radius: 40px;
  object-fit: contain;
  max-width: 500px;
}
.investor-detail-page-container .content .market .details {
  font-family: "Proxima Nova", sans-serif;
}
.investor-detail-page-container .content .market .details .header {
  font-size: 40px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 30px;
  line-height: 50px;
}
.investor-detail-page-container .content .market .details .body {
  font-size: 16px;
  font-weight: 400;
  line-height: 35px;
}
.investor-detail-page-container .content .app-spec {
  display: flex;
  justify-content: center;
}
.investor-detail-page-container .content .team-container {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.investor-detail-page-container .content .team-container .header {
  font-size: 40px;
  color: var(--secondary-color-1);
  font-weight: 700;
  margin: 0;
}
.investor-detail-page-container .content .team-container .subheader {
  font-size: 16px;
  color: var(--secondary-color-1);
  font-weight: 400;
  text-align: center;
  line-height: 30px;
}
.investor-detail-page-container .content .team-container .team {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.investor-detail-page-container .content .team-container .team .member {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.investor-detail-page-container .content .team-container .team .member .member-profile {
  max-width: 200px;
}
.investor-detail-page-container .content .team-container .team .member .member-detail {
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  background-color: var(--secondary-color-1);
}
.investor-detail-page-container .content .team-container .team .member .member-detail p {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: white;
  margin-bottom: 6px;
}
.investor-detail-page-container .content .team-container .team .member .member-detail span {
  font-size: 12px;
  font-weight: 400;
  color: #F4F5F6;
}
.investor-detail-page-container .content .why-invest, .investor-detail-page-container .content .get-intouch {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  flex-direction: column;
}
.investor-detail-page-container .content .why-invest .header, .investor-detail-page-container .content .get-intouch .header {
  font-size: 32px;
  color: var(--secondary-color-1);
  font-weight: 700;
  line-height: 36px;
}
.investor-detail-page-container .content .why-invest .subheader, .investor-detail-page-container .content .get-intouch .subheader {
  color: #949494;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  max-width: 600px;
  text-align: center;
}
.investor-detail-page-container .content .why-invest .subheader > a, .investor-detail-page-container .content .get-intouch .subheader > a {
  color: var(--primary-color-1);
  text-decoration: underline;
  text-decoration-color: var(--primary-color-1);
}
.investor-detail-page-container .content .why-invest .form, .investor-detail-page-container .content .get-intouch .form {
  display: flex;
  animation: fadeIn 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .investor-detail-page-container .content .about {
    flex-direction: column;
    row-gap: 24px;
  }
  .investor-detail-page-container .content .highlights .highlight {
    gap: 20px;
  }
  .investor-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .investor-detail-page-container .content .market {
    row-gap: 40px;
  }
  .investor-detail-page-container .content .market .image {
    width: 100%;
  }
  .investor-detail-page-container .content .market .details .header br {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .investor-detail-page-container .content .about {
    flex-direction: column;
    row-gap: 24px;
  }
  .investor-detail-page-container .content .highlights .highlight {
    gap: 20px;
  }
  .investor-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .investor-detail-page-container .content .market {
    row-gap: 40px;
  }
  .investor-detail-page-container .content .market .image {
    width: 100%;
  }
  .investor-detail-page-container .content .market .details .header br {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .investor-detail-page-container .content .about {
    text-align: center;
  }
  .investor-detail-page-container .content .highlights {
    text-align: center;
  }
  .investor-detail-page-container .content .highlights .highlight {
    justify-content: center;
    gap: 20px;
  }
  .investor-detail-page-container .content .highlights .highlight > div {
    max-width: 300px;
  }
  .investor-detail-page-container .content .market {
    row-gap: 40px;
    text-align: center;
  }
  .investor-detail-page-container .content .market .image {
    width: 100%;
  }
  .investor-detail-page-container .content .market .details .header br {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/InvestorPage/modules/InvestorDetailPage/investorDetailPage.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;AADJ;AAEI;EACI,oBAAA;AAAR;AACQ;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AACZ;AACQ;EACI,aAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,+BAAA;AACZ;AAAY;EACI,WAAA;AAEhB;AAAY;EACI,SAAA;AAEhB;AADgB;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAGpB;AAAY;EACI,SAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAGpB;AACQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AACZ;AAAY;EACI,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAEhB;AAAY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;AAEhB;AAAY;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAEhB;AADgB;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAGpB;AAFoB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AAIxB;AAFoB;EACI,6BAAA;EACA,mBAAA;AAIxB;AAFoB;EACI,+BAAA;EACA,mBAAA;AAIxB;AAFoB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAIxB;AACQ;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACZ;AAAY;EACI,SAAA;AAEhB;AAAY;EACI,mBAAA;EACA,mBAAA;EACA,gBAAA;AAEhB;AAAY;EACI,uCAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAGpB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAGpB;AACQ;EACI,aAAA;EACA,uBAAA;AACZ;AACQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AACZ;AAAY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;AAEhB;AAAY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAEhB;AAAY;EACI,aAAA;EACA,WAAA;EACA,eAAA;AAEhB;AADgB;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAGpB;AAFoB;EACI,gBAAA;AAIxB;AAFoB;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0CAAA;AAIxB;AAHwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAK5B;AAHwB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAK5B;AACQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AACZ;AAAY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAEhB;AADgB;EACI,6BAAA;EACA,0BAAA;EACA,6CAAA;AAGpB;AAAY;EACI,aAAA;EACA,sBAAA;AAEhB;AAEI;EACI;IAAO,UAAA;EACb;EAAM;IAAO,UAAA;EAGb;AACF;;AC7MY;ED+MA;IACI,sBAAA;IACA,aAAA;EAEd;EACc;IACI,SAAA;EAClB;EAAkB;IACI,gBAAA;EAEtB;EAEU;IACI,aAAA;EAAd;EACc;IACI,WAAA;EAClB;EAGsB;IAAK,aAAA;EAA3B;AACF;AC1OY;EDsNA;IACI,sBAAA;IACA,aAAA;EAuBd;EApBc;IACI,SAAA;EAsBlB;EArBkB;IACI,gBAAA;EAuBtB;EAnBU;IACI,aAAA;EAqBd;EApBc;IACI,WAAA;EAsBlB;EAlBsB;IAAK,aAAA;EAqB3B;AACF;AC/PY;EDoPA;IACI,kBAAA;EAcd;EAZU;IACI,kBAAA;EAcd;EAbc;IACI,uBAAA;IACA,SAAA;EAelB;EAdkB;IACI,gBAAA;EAgBtB;EAZU;IACI,aAAA;IACA,kBAAA;EAcd;EAbc;IACI,WAAA;EAelB;EAXsB;IAAK,aAAA;EAc3B;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.investor-detail-page-container {\n    width: 100%;\n    .content {\n        animation: fadeIn 1s;\n        .hero-banner {\n            width: 100%;\n            max-height: 520px;\n            object-fit: contain;\n        }\n        .about {\n            display: flex;\n            width: 100%;\n            margin-top: 80px;\n            font-family: 'Proxima Nova', sans-serif;\n            color: var(--secondary-color-1);\n            > div {\n                width: 100%;\n            }\n            div:first-child {\n                flex: 1;\n                p {\n                    font-size: 30px;\n                    font-style: normal;\n                    font-weight: 600;\n                    margin: 0;\n                }\n            }\n            div:last-child {\n                flex: 2;\n                span {\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: 30px;\n                    text-align: justify;\n                }\n            }\n        }\n        .highlights {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .top-header {\n                color: var(--primary-color-1);\n                font-size: 16px;\n                font-weight: 700;\n                margin: 0;\n            }\n            .header {\n                font-size: 40px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                margin: 0;\n            }\n            .highlight {\n                display: flex;\n                justify-content: space-between;\n                flex-wrap: wrap;\n                column-gap: 20px;\n                > div {\n                    max-width: 320px;\n                    background-color: #FFF8E2;\n                    border-radius: 40px;\n                    padding: 50px;\n                    .number, .title {\n                        font-size: 16px;\n                        font-weight: 700;\n                        margin: 0;\n                    }\n                    .number {\n                        color: var(--primary-color-1);\n                        margin-bottom: 16px;\n                    }\n                    .title {\n                        color: var(--secondary-color-1);\n                        margin-bottom: 18px;\n                    }\n                    .desc {\n                        color: var(--secondary-color-1);\n                        font-size: 14px;\n                        font-weight: 400;\n                        line-height: 30px;\n                    }\n                }\n            }\n        }\n        .market {\n            display: flex;\n            width: 100%;\n            flex-wrap: wrap;\n            column-gap: 100px;\n            > div {\n                flex: 1;\n            }\n            .image {\n                border-radius: 40px;\n                object-fit: contain;\n                max-width: 500px;\n            }\n            .details {\n                font-family: 'Proxima Nova', sans-serif;\n                .header {\n                    font-size: 40px;\n                    font-weight: 600;\n                    margin: 0;\n                    margin-bottom: 30px;\n                    line-height: 50px;\n                }\n                .body {\n                    font-size: 16px;\n                    font-weight: 400;\n                    line-height: 35px;\n                }\n            }\n        }\n        .app-spec {\n            display: flex;\n            justify-content: center;\n        }\n        .team-container {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .header {\n                font-size: 40px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                margin: 0;\n            }\n            .subheader {\n                font-size: 16px;\n                color: var(--secondary-color-1);\n                font-weight: 400;\n                text-align: center;\n                line-height: 30px;\n            }\n            .team {\n                display: flex;\n                width: 100%;\n                flex-wrap: wrap;\n                .member {\n                    flex: 1;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    .member-profile {\n                        max-width: 200px;\n                    }\n                    .member-detail {\n                        height: 70px;\n                        width: 100%;\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        text-align: center;\n                        justify-content: center;\n                        background-color: var(--secondary-color-1);\n                        p {\n                            margin: 0;\n                            font-size: 14px;\n                            font-weight: 700;\n                            color: white;\n                            margin-bottom: 6px;\n                        }\n                        span {\n                            font-size: 12px;\n                            font-weight: 400;\n                            color: #F4F5F6;\n                        }\n                    }\n                }\n            }\n        }\n        .why-invest, .get-intouch {\n            display: flex;\n            width: 100%;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            flex-direction: column;\n            .header {\n                font-size: 32px;\n                color: var(--secondary-color-1);\n                font-weight: 700;\n                line-height: 36px;\n            }\n            .subheader {\n                color: #949494;\n                font-size: 20px;\n                font-weight: 400;\n                line-height: 32px;\n                max-width: 600px;\n                text-align: center;\n                > a {\n                    color: var(--primary-color-1);\n                    text-decoration: underline;\n                    text-decoration-color: var(--primary-color-1);\n                } \n            }\n            .form {\n                display: flex;\n                animation: fadeIn .5s;\n            }\n        }\n    }\n    @keyframes fadein {\n        from { opacity: 0; }\n        to   { opacity: 1; }\n    }\n}\n@include media(tablet, mobile) {\n    .investor-detail-page-container {\n        .content {\n            .about {\n                flex-direction: column;\n                row-gap: 24px;\n            }\n            .highlights {\n                .highlight {\n                    gap: 20px;\n                    > div {\n                        max-width: 300px;\n                    }\n                }\n            }\n            .market {\n                row-gap: 40px;\n                .image {\n                    width: 100%;\n                }\n                .details {\n                    .header {\n                        br { display: none; }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .investor-detail-page-container {\n        .content {\n            .about {\n                text-align: center;\n            }\n            .highlights {\n                text-align: center;\n                .highlight {\n                    justify-content: center;\n                    gap: 20px;\n                    > div {\n                        max-width: 300px;\n                    }\n                }\n            }\n            .market {\n                row-gap: 40px;\n                text-align: center;\n                .image {\n                    width: 100%;\n                }\n                .details {\n                    .header {\n                        br { display: none; }\n                    }\n                }\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
